import DevExpress from 'devextreme'

import * as _ from 'underscore'

export class PopupHelper {
    static mergeWithDefaultOptions(options: DevExpress.ui.dxPopupOptions): DevExpress.ui.dxPopupOptions {
        const defaultOptions = {
            deferRendering: false,
            showTitle: true,
            showCloseButton: true,
            visible: false,
        }

        return _.assign({}, defaultOptions, options)
    }
}